import { Typography } from "@mui/material";
import ListImages from "./list_pool_images";
import ListTablesRestaurant from "./list_tables_restaurant";
import ListUsersRestaurants from "./list_users_restaurant";
import ListCategories from "./menu_components/list_categories";
import ListProducts from "./menu_components/list_products";
import WeeklyMenuScheduler from "./menu_components/scheduler";
import MenuRestaurant from "./menu_restaurant";

import RestaurantLinktree from "../linktree/restaurant_linktree";
import MainSurveys from "../surveys/main_surveys";
import ReservationMain from "../reservations/reservation_main";

export default function RestaurantAdminPanel({ restaurant, activeTab, productFilter, imageFilter, onRestaurantNameUpdate }) {
  console.log(activeTab);
  switch (activeTab) {
    case "Categorias":
      return <ListCategories restaurantId={restaurant.id} />;
    case "Usuarios":
      return <ListUsersRestaurants idRestaurant={restaurant.id} titleCreate={"Crear Usuario"} role={[2, 3, 4]} waiters />;
    case "Mesas":
      return <ListTablesRestaurant idTable={restaurant.id} titleCreate={"Crear Mesa"} />;
    case "Menú":
      return <MenuRestaurant restaurantId={restaurant.id} />;
    case "Productos":
      return <ListProducts restaurantId={restaurant.id} initialFilter={productFilter} />;
    case "Agenda":
      return <WeeklyMenuScheduler restaurantId={restaurant.id} />;
    case "Imágenes":
      return <ListImages restaurantId={restaurant.id} initialFilter={imageFilter} />;
    case 'Reservas':
      return <ReservationMain restaurantId={restaurant.id} />;
    case 'Linktree':
      return <RestaurantLinktree restaurant={restaurant} />;
    case 'Encuestas':
      return <MainSurveys restaurantId={restaurant.id} />;
    default:
      return <Typography>Selecciona una opción del menú lateral</Typography>;
  }
}